import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import EditWebinarForm from "components/Admin/Webinar/EditWebinarForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";
import _, { cloneDeep } from "lodash";
import shortid from "shortid";
import { sortExpertsByNumeration } from "utils/sort-experts";
import { getGallery, toggleGallery } from "../../../actions/webinars";

const userRoles = [0, 1, 2, 3, 4, 5, 6];

const { CPD_STATUSES, REF_TYPES } = constants;

const {
  UPDATE_WEBINAR_SAGA,
  UPDATE_WEBINAR_SAGA_WITH_SPEAKER,
  MODAL_TYPE_WEBINAR,
} = constants;

const {
  setTempWebinar,
  updateWebinarSaga,
  updateWebinarSagaWithSpeaker,
  cleanErrors,
  loadAdminUsersWebinarsSaga,
  loadAdminWebinarSaga,
  loadSponsorsSuggestionsSaga,
  loadPartnersSuggestionsSaga,
  adminUserFilter,
  showModal,
  adminPostAssignedUsersSaga,
  loadDisciplinesSaga,
  loadSponsorUsersSuggestionsSaga,
  getZoomAccounts,
} = actions;

class EditWebinar extends Component {
  static propTypes = {
    createWebinar: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);

    const refTypeUpperCase =
      this.props.webinar.ref_type && this.props.webinar.ref_type.toUpperCase();

    this.state = {
      per_page: 5000,
      page: 1,
      searchQuery: {
        order: {
          created_at: "desc",
        },
      },
      webinar: {
        gallery_photo: null,
        webinar_type: "online",
        start_date: new Date(),
        end_date: new Date(),
        webinar_title: "",
        status: "published",
        partnerships_id: "",
        faculty: false,
        generate_qrcode: false,
        price: 0,
        sponsor_ids: [],
        partnerships_ids: [],
        user_sponsor_ids: [],
        cpd_points: "",
        int_cpd_points: "",
        ext_cpd_points: "",
        cpd_points: "external",
        vimeo_url: "",
        document: "",
        document_url: "",
        add_custom_text: false,
        custom_text_1: "",
        custom_text_1: "",
        custom_text_2: "",
        ppt_document: "",
        ppt_document_url: "",
        pptDocumentType: "",
        evaluation_summary: "",
        evaluation_summary_url: "",
        evaluationSummaryType: "",
        attachmentPreview: "",
        duration: "",
        attachmentType: "",
        gms_study_days: "",
        cpd_status: "",
        subscription_sponsor: false,
        sponsor_newsleter_title: "",
        counties: [],
        disciplines: [],
        search_disciplines: [],
        assignedUsers: [],
        user_types: [],
        zoom_account: "",
        zoom_uid: "",
        ...props.webinar,
        ref_type: REF_TYPES[refTypeUpperCase],
        spd_quizzes_attributes: [
          ...(this.props.webinar.spd_quizzes || []),
          {
            question: "",
            correct: false,
          },
        ].map((quiz) => ({ ...quiz, __id: shortid.generate() })),
        sessions_attributes: [
          ...((this.props.webinar.sessions &&
            this.props.webinar.sessions.map((session) => {
              session.rooms_attributes = session.rooms || [
                {
                  title: "",
                },
              ];
              delete session.rooms;
              session.rooms_attributes = session.rooms_attributes.map(
                (room) => ({ ...room, __id: shortid.generate() }),
              );
              session.__id = shortid.generate();
              return session;
            })) ||
            [
              {
                title: "",
                start_time: moment().set("seconds", 0),
                end_time: moment().set("seconds", 0),
                rooms_attributes: [
                  {
                    __id: shortid.generate(),
                    title: "",
                  },
                ],
              },
            ].map((session) => ({ ...session, __id: shortid.generate() }))),
        ],
        experts_attributes: [
          ...sortExpertsByNumeration(this.props.webinar.experts || []),
          {
            name: "",
            location: "",
            expert_type: "",
            expert_avatar_url: "",
            numeration: "",
          },
        ].map((expert) => ({ ...expert, __id: shortid.generate() })),
      },
      is_industry:
        Array.isArray(props.webinar && props.webinar.user_types) &&
        props.webinar.user_types.length === 1 &&
        props.webinar.user_types[0] === 11,
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentDidMount() {
    if (!this.props.gallery.length) this.props.getGallery();
  }

  componentWillReceiveProps(props) {
    if (
      ((this.props.webinar &&
        this.props.webinar.user_types &&
        this.props.webinar.user_types.length) ||
        0) !==
        ((props.webinar &&
          props.webinar.user_types &&
          props.webinar.user_types.length) ||
          0) &&
      props.webinar.user_types.length !== 0
    ) {
      let fieldValue = cloneDeep(props.webinar.user_types);
      const ipnaMemberIndex = fieldValue.indexOf(8);

      if (ipnaMemberIndex > -1) {
        fieldValue[ipnaMemberIndex] = 8;
      }

      this.props.loadDisciplines(fieldValue);
    }
    if (!_.isEqual(this.props.webinar, props.webinar)) {
      const refTypeUpperCase =
        props.webinar.ref_type && props.webinar.ref_type.toUpperCase();
      let assigned_ids = props.webinar.assigned_ids;

      if (
        props.location.state &&
        props.location.state.from === "addUsersWebinar"
      ) {
        assigned_ids =
          this.state.webinar.assigned_ids || props.webinar.assigned_ids;
      }
      if (assigned_ids && assigned_ids.length) {
        this.props.adminPostAssignedUsersSaga(assigned_ids);
      }

      this.setState({
        is_industry:
          Array.isArray(props.webinar.user_types) &&
          props.webinar.user_types.length === 1 &&
          props.webinar.user_types[0] === 11,
        webinar: {
          ...this.state.webinar,
          ...props.webinar,
          add_custom_text: Boolean(
            props.webinar.custom_text_1 || props.webinar.custom_text_2,
          ),
          gallery_photo:
            (props.webinar.galery_images &&
              props.webinar.galery_images.length &&
              props.webinar.galery_images[0].id) ||
            null,
          search_disciplines: props.webinar.search_disciplines,
          start_date: moment(
            props.webinar.start_date || this.state.webinar.start_date,
          ),
          assigned_ids,
          assignedUsers:
            props.webinar.assigned_ids || this.props.webinar.assigned_ids,
          end_date: moment(
            props.webinar.end_date || this.state.webinar.end_date,
          ),
          spd_quizzes_attributes: [
            ...(props.webinar.spd_quizzes || []),
            {
              question: "",
              correct: false,
            },
          ].map((quiz) => ({ ...quiz, __id: shortid.generate() })),
          sessions_attributes: [
            ...((props.webinar.sessions &&
              props.webinar.sessions.map((session) => {
                session.rooms_attributes = session.rooms || [
                  {
                    title: "",
                  },
                ];
                delete session.rooms;
                session.rooms_attributes = session.rooms_attributes.map(
                  (room) => ({ ...room, __id: shortid.generate() }),
                );
                session.__id = shortid.generate();
                return session;
              })) || [
              {
                __id: shortid.generate(),
                title: "",
                start_time: moment().set("seconds", 0),
                end_time: moment().set("seconds", 0),
                rooms_attributes: [
                  {
                    __id: shortid.generate(),
                    title: "",
                  },
                ],
              },
            ]),
          ],
          sponsor_ids:
            props.webinar.sponsor_ids && props.webinar.sponsor_ids.length
              ? props.webinar.sponsor_ids
              : [],
          partnerships_ids:
            props.webinar.partnerships_ids &&
            props.webinar.partnerships_ids.length
              ? props.webinar.partnerships_ids
              : [],
          ref_type: REF_TYPES[refTypeUpperCase],
          experts_attributes: [
            ...sortExpertsByNumeration(props.webinar.experts || []),
            {
              name: "",
              location: "",
              expert_type: "",
              expert_avatar_url: "",
              numeration: "",
            },
          ].map((expert) => ({ ...expert, __id: shortid.generate() })),
        },
      });
    }

    if (!_.isEqual(this.props.users, props.users)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            assigned_users: props.users.filter(
              (user) =>
                this.state.webinar.assigned_ids.indexOf(user.id.toString()) >
                -1,
            ),
          },
        },
      });
    }

    if (
      props.csvImportedIds &&
      !_.isEqual(this.props.csvImportedIds, props.csvImportedIds)
    ) {
      const existing = this.state.webinar.assigned_ids || [];
      const merged = _.union(
        existing.map(String),
        props.csvImportedIds.map(String),
      );
      this.props.adminPostAssignedUsersSaga(merged);
      this.setState({
        webinar: { ...this.state.webinar, assigned_ids: merged },
      });
      this.props.clearCsvImportedIds();
    }
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadWebinar(this.props.params.id);
    this.props.loadAllSponsors();
    this.props.loadAllPartners();
    this.props.loadDisciplines();
    if (this.props.role === "admin") {
      this.props.loadAdminUsersWebinar(this.props.params.id);
    }
    this.props.adminPostAssignedUsersSaga(this.state.webinar.assigned_ids);
    this.props.loadAllSponsorUsers();
    this.props.loadZoomAccounts();
  }

  onConsultantOrHD = (allCounties) => {
    let newWebinar = {};

    const selectedAllCounties = _.isEqual(
      allCounties,
      this.state.webinar.counties,
    );
    if (!this.state.webinar.counties || !selectedAllCounties) {
      newWebinar = {
        ...newWebinar,
        ...{ counties: allCounties.map((county) => county) },
      };
    }

    if (
      this.state.webinar.ext_cpd_points !== 0 &&
      this.state.webinar.int_cpd_points !== 0
    ) {
      newWebinar = {
        ...newWebinar,
        ...{ ext_cpd_points: 0, int_cpd_points: 0 },
      };
    }

    if (!_.isEmpty(newWebinar)) {
      this.setState({ webinar: { ...this.state.webinar, ...newWebinar } });
    }
  };

  onFieldChange = (e) => {
    const fieldValue = [...e.target.value];
    let input = inputFormatter.formatField(e.target.name, e.target.value);

    const webinarData = {
      ...this.state.webinar,
      ...{
        [e.target.name]: input,
      },
    };
    if (e.target.name === "user_types") {
      const ipnaMemberIndex = fieldValue.indexOf(8);

      if (ipnaMemberIndex > -1) {
        fieldValue[ipnaMemberIndex] = 8;
      }

      this.props.loadDisciplines(fieldValue);
    }

    this.setState({ webinar: webinarData });
  };

  onSponsorChange = (sponsor_ids) => {
    this.onFieldChange({
      target: {
        name: "sponsor_ids",
        value: (sponsor_ids || []).map((sponsor) => sponsor.value),
      },
    });
  };

  onPartnerChange = (partnerships_ids) => {
    this.onFieldChange({
      target: {
        name: "partnerships_ids",
        value: (partnerships_ids || []).map((partner) => partner.value),
      },
    });
  };

  onSponsorUsersChange = (user_sponsor_ids) => {
    console.log("onSponsorUsersChange", user_sponsor_ids);

    this.onFieldChange({
      target: {
        name: "user_sponsor_ids",
        value: (user_sponsor_ids || []).map((sponsorUser) => sponsorUser.value),
      },
    });
  };

  onCountiesChange = (counties) => {
    this.onFieldChange({
      target: {
        name: "counties",
        value: (counties || []).map((county) => county.value),
      },
    });
  };

  onUserTypeChange = (roles) => {
    this.onFieldChange({
      target: {
        name: "user_types",
        value: (roles || []).map((role) => role.value),
      },
    });
  };

  onIsIndustryChange = (e) => {
    const is_industry = e.target.checked;
    this.setState({
      is_industry,
      webinar: {
        ...this.state.webinar,
        user_types: is_industry ? [11] : [],
      },
    });
  };

  onSelectChangeDisciplineWebinar = (disciplines) => {
    this.onFieldChange({
      target: {
        name: "disciplines",
        value: (disciplines || []).map(
          (discipline) => discipline.value || discipline.id,
        ),
      },
    });
  };
  onSelectChangeDisciplineWebinarSearch = (disciplines) => {
    this.onFieldChange({
      target: {
        name: "search_disciplines",
        value: (disciplines || []).map(
          (discipline) => discipline.value || discipline.id,
        ),
      },
    });
  };

  onNewsletterChange = (e) => {
    const subscription_sponsor = e.target.value;
    this.onFieldChange({
      target: {
        name: "subscription_sponsor",
        value: subscription_sponsor === "true",
      },
    });
  };
  onLandingShowChange = (e) => {
    const landing_show = e.target.value;
    this.onFieldChange({
      target: {
        name: "landing_show",
        value: landing_show === "true",
      },
    });
  };
  onEventWebinarChange = (e) => {
    const for_event = e.target.value;
    this.onFieldChange({
      target: {
        name: "for_event",
        value: for_event === "true",
      },
    });
  };
  onGenerateQRChange = (e) => {
    const generate_qrcode = e.target.value;
    this.onFieldChange({
      target: {
        name: "generate_qrcode",
        value: generate_qrcode === "true",
      },
    });
  };
  onShowUserQuestions = (e) => {
    const show_user_questions = e.target.value;
    this.onFieldChange({
      target: {
        name: "show_user_questions",
        value: show_user_questions === "true",
      },
    });
  };

  onAddCustomTextChange = (e) => {
    const isEnabled = e.target.value === "true";
    this.setState((prevState) => ({
      webinar: {
        ...prevState.webinar,
        add_custom_text: isEnabled,
        ...(!isEnabled && { custom_text_1: "", custom_text_2: "" }),
      },
    }));
  };

  onAssignedUsersChange = (assignedUsers) => {
    this.onFieldChange({
      target: {
        name: "assigned_ids",
        value: assignedUsers,
      },
    });
  };

  onWebinarTypeChange = (e) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        webinar_type: e.target.value,
      },
    };

    this.setState({ webinar: webinarData });
  };

  onWebinarFacultyTypeChange = (e) => {
    if (!e.target.checked) {
      const webinarData = {
        ...this.state.webinar,
        ...{
          price: 0,
          faculty: e.target.checked,
        },
      };
      this.setState({ webinar: webinarData });
    } else {
      const webinarData = {
        ...this.state.webinar,
        ...{
          faculty: e.target.checked,
        },
      };
      this.setState({ webinar: webinarData });
    }
  };

  onCpdPointsChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const cpds = {
      ...(this.state.webinar.cpd_points == "internal"
        ? {
            [e.target.name]: input,
            ext_cpd_points: 0,
          }
        : {}),
      ...(this.state.webinar.cpd_points == "external"
        ? {
            [e.target.name]: input,
            int_cpd_points: 0,
          }
        : {}),
      ...(this.state.webinar.cpd_points == "both"
        ? {
            [e.target.name]: input,
          }
        : {}),
    };
    const webinarData = { ...this.state.webinar, ...cpds };

    this.setState({ webinar: webinarData });
  };

  onCpdTypeChange = (e) => {
    const value = e.target.value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        cpd_status: e.target.value,
        ...(value !== CPD_STATUSES.granted
          ? {
              ext_cpd_points: 0,
              int_cpd_points: 0,
              icgp_ref: this.state.webinar.icgp_ref || "",
            }
          : {}),
      },
    });
  };

  onCertificateRefChange = (e) => {
    const value = e.target.value;
    let refType;

    if (value === REF_TYPES.ICGP) {
      refType = {
        icgp_ref: this.state.webinar.icgp_ref || "",
      };
    } else if (value === REF_TYPES.RCPI) {
      refType = {
        rcpi_ref: this.state.webinar.rcpi_ref || "",
      };
    } else {
      refType = {
        ipna_ref: this.state.webinar.ipna_ref || "",
      };
    }

    this.setState({
      webinar: {
        ...this.state.webinar,
        ref_type: e.target.value,
        ...refType,
      },
    });
  };

  onDateChange = (field, value) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        [field]: value,
      },
    };

    this.setState({ webinar: webinarData });
  };

  onQuizAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: [
            ...this.state.webinar.spd_quizzes_attributes,
            ...[{ question: "", correct: false, __id: shortid.generate() }],
          ],
        },
      },
    });
  };

  onQuizRemove = (__id) => {
    let quizzes = this.state.webinar.spd_quizzes_attributes.slice();
    const quiz = quizzes.find((quiz) => quiz.__id == __id);
    if (quiz.id) {
      this.onQuizChange(__id, "_destroy", true);
    } else {
      quizzes = quizzes.filter((quiz) => quiz.__id != __id);
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            spd_quizzes_attributes: quizzes,
          },
        },
      });
    }
  };

  onQuizChange = (__id, field, value) => {
    let cpdQuiz = this.state.webinar.spd_quizzes_attributes.slice();
    let quiz = cpdQuiz.find((webinar) => webinar.__id == __id);
    quiz[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: cpdQuiz,
        },
      },
    });
  };
  onSessionAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          sessions_attributes: [
            ...this.state.webinar.sessions_attributes,
            ...[
              {
                __id: shortid.generate(),
                title: "",
                start_time: moment().set("seconds", 0),
                end_time: moment().set("seconds", 0),
                rooms_attributes: [
                  {
                    __id: shortid.generate(),
                    title: "",
                  },
                ],
              },
            ],
          ],
        },
      },
    });
  };

  onSessionRemove = (__id) => {
    let sessions_attributes = this.state.webinar.sessions_attributes.slice();
    const session = sessions_attributes.find((session) => session.__id == __id);
    if (session.id) {
      this.onSessionChange(__id, "_destroy", true);
    } else {
      sessions_attributes = sessions_attributes.filter(
        (session) => session.__id != __id,
      );
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            sessions_attributes,
          },
        },
      });
    }
  };

  onSessionChange = (__id, field, value) => {
    const sessions_attributes = this.state.webinar.sessions_attributes.slice();
    const session = sessions_attributes.find((session) => session.__id == __id);
    session[field] = value;
    const webinarData = {
      ...this.state.webinar,
      ...{
        sessions_attributes,
      },
    };
    this.setState({ webinar: webinarData });
  };

  // Experts
  onExpertAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: [
            ...this.state.webinar.experts_attributes,
            ...[
              {
                name: "",
                type: "",
                location: "",
                avatar: null,
                __id: shortid.generate(),
              },
            ],
          ],
        },
      },
    });
  };

  onExpertRemove = (__id) => {
    let experts = this.state.webinar.experts_attributes.slice();
    const expert = experts.find((expert) => expert.__id == __id);
    if (expert.id) {
      this.onExpertChange(__id, "_destroy", true);
      this.onSpeakerRemoveSubmit();
    } else {
      experts = experts.filter((expert) => expert.__id != __id);
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            experts_attributes: experts,
          },
        },
      });
    }
  };

  onExpertChange = (__id, field, value) => {
    let experts = this.state.webinar.experts_attributes.slice();
    let expert = experts.find((webinar) => webinar.__id == __id);
    expert[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: experts,
        },
      },
    });
  };

  onAttachmentChange = (file) => {
    if (Boolean(file)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            document: file,
            document_url: URL.createObjectURL(file),
            attachmentType: file.type,
          },
        },
      });
    } else {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            document: null,
            document_url: "",
            attachmentType: "",
          },
        },
      });
    }
  };

  onPptDocumentChange = (file) => {
    if (Boolean(file)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            ppt_document: file,
            ppt_document_url: URL.createObjectURL(file),
            pptDocumentType: file.type,
          },
        },
      });
    } else {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            ppt_document: null,
            ppt_document_url: "",
            pptDocumentType: "",
          },
        },
      });
    }
  };

  onEvaluationSummaryChange = (file) => {
    if (Boolean(file)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            evaluation_summary: file,
            evaluation_summary_url: URL.createObjectURL(file),
            evaluationSummaryType: file.type,
          },
        },
      });
    } else {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            evaluation_summary: null,
            evaluation_summary_url: "",
            evaluationSummaryType: "",
          },
        },
      });
    }
  };

  cpdPointsFields = () => {
    const { cpd_points, cpd_status } = this.state.webinar;
    if (cpd_status !== CPD_STATUSES.granted) {
      return [];
    }
    switch (cpd_points) {
      case "external":
        return ["ext_cpd_points"];
      case "internal":
        return ["int_cpd_points"];
      case "both":
        return ["int_cpd_points", "ext_cpd_points"];
      default:
        return [];
    }
  };

  onSubmit = () => {
    const { webinar } = this.state;

    let _webinar = cloneDeep(webinar);
    _webinar.start_date = moment(_webinar.start_date);
    _webinar.end_date = moment(_webinar.end_date);
    _webinar.experts_attributes = webinar.experts_attributes.filter(
      (expert) => {
        if (
          typeof expert.expert_avatar_url == "string" ||
          typeof expert.avatar == "string"
        ) {
          expert.expert_avatar_url = null;
          return expert;
        } else {
          return expert;
        }
      },
    );

    delete _webinar.group_id;

    if (_webinar.document === "") {
      delete _webinar.document;
      delete _webinar.document_url;
      delete _webinar.attachmentType;
    }

    this.props.updateWebinar(_webinar);
  };

  onSpeakerRemoveSubmit = () => {
    const { webinar } = this.state;
    const updatedExperts = webinar.experts_attributes.filter((expert) => {
      if (
        typeof expert.expert_avatar_url == "string" ||
        typeof expert.avatar == "string"
      ) {
        expert.expert_avatar_url = null;
        return expert;
      } else {
        return expert;
      }
    }); // new file, not url

    delete webinar.group_id;

    this.props.updateWebinarRemoveSpeaker({
      ...this.state.webinar,
      experts_attributes: updatedExperts,
    });
    setTimeout(() => {
      this.props.cleanErrors();
      this.props.loadWebinar(this.props.params.id);
      this.props.loadAllSponsors();
      this.props.loadAllPartners();
    }, 500);
  };
  goToAddUsersPage = () => {
    this.props.setTempWebinar(this.state.webinar);
    this.props.router.push(`/webinars/${this.props.params.id}/addUsers`);
  };
  showUsersModal = (additional = {}) => {
    this.props.showUsersModal(
      {
        users: this.props.users,
      },
      additional,
    );
  };
  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const reorder = (list, startIndex, endIndex) => {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);

      return result;
    };

    const speakers = reorder(
      this.state.webinar.experts_attributes,
      result.source.index,
      result.destination.index,
    ).map((speaker, index) => {
      speaker.numeration = index + 1;
      return speaker;
    });

    this.setState({
      ...this.state,
      webinar: {
        ...this.state.webinar,
        experts_attributes: speakers,
        experts: speakers.filter((speaker) => speaker.expert_type),
      },
    });
  }

  handleSelectImage(e) {
    this.setState({
      webinar: {
        ...this.state.webinar,
        gallery_photo: Number(e.target.id),
      },
    });
    this.toggleGallery();
  }
  removeGallery() {
    this.setState({
      webinar: {
        ...this.state.webinar,
        gallery_photo: "",
      },
    });
  }

  toggleGallery() {
    if (!this.props.gallery.length) this.props.getGallery();
    this.props.toggleGallery();
  }

  render() {
    const { errors, errorsFrontend, sponsors, partners, sponsorUsers } =
      this.props;

    return (
      <main className="site--width clearfix-c">
        <EditWebinarForm
          toggleGallery={this.toggleGallery.bind(this)}
          galleryOpen={this.props.galleryOpen}
          handleSelectImage={this.handleSelectImage.bind(this)}
          removeGallery={this.removeGallery.bind(this)}
          gallery={this.props.gallery}
          role={this.props.role}
          onSessionAdd={this.onSessionAdd}
          onSessionRemove={this.onSessionRemove}
          onSessionChange={this.onSessionChange}
          onFieldChange={this.onFieldChange}
          webinar={this.state.webinar}
          onQuizAdd={this.onQuizAdd}
          onQuizChange={this.onQuizChange}
          onDateChange={this.onDateChange}
          onSubmit={this.onSubmit}
          onQuizRemove={this.onQuizRemove}
          errors={validator.formatErrors(errors, errorsFrontend)}
          cpdPointsFields={this.cpdPointsFields()}
          onCpdPointsChange={this.onCpdPointsChange}
          onCountiesChange={this.onCountiesChange}
          onDisciplinesChange={this.onDisciplinesChange}
          onWiminChange={this.onWiminChange}
          goToAddUsersPage={this.goToAddUsersPage}
          onAssignedUsersChange={this.onAssignedUsersChange}
          onUserTypeChange={this.onUserTypeChange}
          isIndustry={this.state.is_industry}
          onIsIndustryChange={this.onIsIndustryChange}
          onCpdTypeChange={this.onCpdTypeChange}
          onCertificateRefChange={this.onCertificateRefChange}
          sponsorsOptions={sponsors}
          partnersOptions={partners}
          search_disciplines={this.props.search_disciplines}
          sponsorUsersOptions={sponsorUsers}
          onConsultantOrHD={this.onConsultantOrHD}
          onWebinarTypeChange={this.onWebinarTypeChange}
          onExpertAdd={this.onExpertAdd}
          onExpertRemove={this.onExpertRemove}
          onExpertChange={this.onExpertChange}
          onSponsorChange={this.onSponsorChange}
          onSponsorUsersChange={this.onSponsorUsersChange}
          showUsersModal={this.showUsersModal}
          onPartnerChange={this.onPartnerChange}
          onWebinarFacultyTypeChange={this.onWebinarFacultyTypeChange}
          onAttachmentChange={this.onAttachmentChange}
          attachment={this.state.webinar.document}
          attachment_url={this.state.webinar.document_url}
          attachmentType={this.state.webinar.attachmentType}
          onPptDocumentChange={this.onPptDocumentChange}
          ppt_document={this.state.webinar.ppt_document}
          ppt_document_url={this.state.webinar.ppt_document_url}
          pptDocumentType={this.state.webinar.pptDocumentType}
          evaluation_summary={this.state.webinar.evaluation_summary}
          evaluation_summary_url={this.state.webinar.evaluation_summary_url}
          evaluationSummaryType={this.state.webinar.evaluationSummaryType}
          onEvaluationSummaryChange={this.onEvaluationSummaryChange}
          disciplines={this.props.disciplines}
          onSelectChangeDiscipline={this.onSelectChangeDisciplineWebinar}
          onSelectChangeDisciplineSearch={
            this.onSelectChangeDisciplineWebinarSearch
          }
          onLandingShowChange={this.onLandingShowChange}
          onEventWebinarChange={this.onEventWebinarChange}
          onRoomAdd={this.onRoomAdd}
          onRoomRemove={this.onRoomRemove}
          onDragEnd={this.onDragEnd}
          onNewsletterChange={this.onNewsletterChange}
          onGenerateQRChange={this.onGenerateQRChange}
          onShowUserQuestions={this.onShowUserQuestions}
          zoomAccounts={this.props.zoomAccounts}
          onAddCustomTextChange={this.onAddCustomTextChange}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[UPDATE_WEBINAR_SAGA],
    errorsFrontend: state.errors[`${UPDATE_WEBINAR_SAGA}_FRONTEND`],
    users: state.users.assignedUsers.values,
    webinar: state.webinars.tmp,
    sponsors: state.suggestions.sponsor.values,
    partners: state.suggestions.partner.values,
    disciplines: state.disciplines.list.values,
    count: state.disciplines.list.count,
    total_pages: state.disciplines.list.total_pages,
    page: state.disciplines.list.page,
    query: state.disciplines.list.query,
    sponsorUsers: state.suggestions.sponsorUsers.values,
    search_disciplines: state.disciplines.search.values,
    role: state.users.user.role,
    gallery: state.webinars.gallery,
    galleryOpen: state.webinars.galleryOpen,
    zoomAccounts: state.zoom.zoomAccounts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTempWebinar: (webinar) => dispatch(setTempWebinar(webinar)),
    updateWebinar: (webinar) => dispatch(updateWebinarSaga(webinar)),
    updateWebinarRemoveSpeaker: (webinar) =>
      dispatch(updateWebinarSagaWithSpeaker(webinar)),
    cleanErrors: () => dispatch(cleanErrors(UPDATE_WEBINAR_SAGA)),
    loadWebinar: (id) => dispatch(loadAdminWebinarSaga(id, true)),
    loadAllSponsors: () => dispatch(loadSponsorsSuggestionsSaga()),
    loadAllPartners: () => dispatch(loadPartnersSuggestionsSaga()),
    loadAdminUsersWebinar: (id) => dispatch(loadAdminUsersWebinarsSaga(id)),
    userFilter: (query, page) => dispatch(adminUserFilter(query, page)),
    showUsersModal: (contentProps) =>
      dispatch(showModal(MODAL_TYPE_WEBINAR, contentProps)),
    adminPostAssignedUsersSaga: (assigned_ids, onlyAssigned = true) =>
      dispatch(
        adminPostAssignedUsersSaga(assigned_ids, onlyAssigned, 0, {}, 0),
      ),
    dispatch: dispatch,
    loadDisciplines: (userType) =>
      dispatch(loadDisciplinesSaga(1, { discipline_type: userType })),
    loadAllSponsorUsers: () => dispatch(loadSponsorUsersSuggestionsSaga()),
    toggleGallery: () => dispatch(toggleGallery()),
    getGallery: (meta) => dispatch(getGallery(meta)),
    loadZoomAccounts: () => dispatch(getZoomAccounts()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditWebinar);



// WEBPACK FOOTER //
// ./src/containers/Admin/Webinar/EditWebinar.jsx